import React from "react";

import clsx from "clsx";

export interface PointDetailRowProps {
  label: string;
  value: string | number;
  unit?: string;
  className?: string;
  hasBorder?: boolean;
  isChargedPoint?: boolean;
}

export function PointDetailRow({
  label,
  value,
  unit = "pt",
  isChargedPoint = false,
  className = "",
  hasBorder = false,
}: PointDetailRowProps): React.ReactNode {
  return (
    <div
      className={clsx(
        "self-stretch flex flex-row items-center justify-start gap-5",
        hasBorder && "border-[#c8c8c8] border-solid border-t-[1px] pt-2",
        className
      )}
    >
      <div className="flex-1 relative leading-[16px] text-[12px] text-[#5a5a5a]">{label}</div>
      <div
        className={clsx("flex flex-row items-baseline justify-center text-[24px]", {
          "text-message-ok": isChargedPoint,
        })}
      >
        <b className="relative leading-[32px]">{value}</b>
        {unit && <b className="relative text-[16px] leading-[24px] pl-[2px]">{unit}</b>}
      </div>
    </div>
  );
}
